<template>
  <div class="main">
    <div class="header flex-sb-c">
      <div class="logo">
        <img src="@images/logo.png" />
      </div>
      <ul class="mess flex-s-c">
        <li class="user flex-s-c">
          <img :src="userMess.photo?userMess.photo:defaultPhoto" /><span>{{userMess.userName}}</span>
        </li>
        <li class="quit" @click="quit()">退出</li>
      </ul>
    </div>
    <div class="sidebar">
      <ul>
        <li :class="[$route.meta.menuActive==item.active?'active':'']" v-for="item in menuList" @click="$router.push({name:item.link})">
          <!-- <li class="active" v-for="item in menuList" @click="$router.push({name:item.link})"> -->
          <i :class="['iconfont',item.class]"></i>
          <span>{{item.title}}</span>
          <span class="unread" v-if="item.link=='news'&&newsUnread>0"></span>
        </li>

      </ul>
    </div>
    <div class="main-con">
      <div class="nav-title" v-if="!navHide">{{$route.meta.name}}</div>
      <div v-if=returnBut>
        <!-- <el-button type="" icon="el-icon-arrow-left" @click="$router.go(-1)" plain>返回</el-button> -->
        <el-button type="" icon="el-icon-arrow-left" @click="goReturn" plain>返回</el-button>
      </div>
      <router-view />
    </div>
  </div>
</template>
<script>
import gl from '@/api/global';
import { testM } from '@/libs/utils'
export default {
  components: {},
  data() {
    return {
      fullscreenLoading: false,
      loading: "",
      returnBut: false,
      navHide: true,
      menuList: [
        { title: '首页', class: 'icon-1', active: "home", link: 'home' },
        { title: '活动中心', class: 'icon-huodong', active: "serviceCenter", link: 'serviceCenter' },
        { title: '服务日程', class: 'icon-richeng', active: "activitySchedule", link: 'activitySchedule' },
        { title: '我的服务', class: 'icon-fuwu', active: "myService", link: 'myService' },
        { title: '我的展厅', class: 'icon-ziyuan', active: "myHall", link: 'myHall' },
        { title: '我的申请', class: 'icon-wodeshenqing', active: "myApply", link: 'myApply' },
        // { title: '服务记录', class: 'icon-jilu', active: "serviceRecord", link: 'serviceRecord' },
        { title: '我的日程', class: 'icon-calendar', active: "mySchedule", link: 'mySchedule' },
        { title: '我的积分', class: 'icon-jifen', active: "myScore", link: 'myScore' },
        { title: '规章条例', class: 'icon-guizhang', active: "rules", link: 'rules' },
        { title: '帮助中心', class: 'icon-bangzhuzhongxin', active: "help", link: 'help' },
        { title: '我的消息', class: 'icon-xiaoxi', active: "news", link: 'news' },
        { title: '基本资料', class: 'icon-jibenziliao', active: "info", link: 'info' },
        // { title: '当前展览', class: 'icon-yijianfankui', active: "feedback", link: 'feedbackAdd' },
      ],
      // userMess: this.$store.state.user.user
      defaultPhoto: require('@images/photo-none.jpg'),
      newsUnread: 0
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user.user
    },
    lastRoute() {
      return this.$store.state.app.lastRoute
    }
  },
  watch: {
    $route(to, form) {
      this.navHide = this.$route.meta.navHide ? true : false
      this.returnBut = this.$route.meta.returnBut ? true : false
      // if (form.name == 'news') {
      this.init()
      // }
    },
  },
  methods: {
    init() {
      // let name = "sss"
      // testM('xiaoming')

      this.$api.messageListNew({ volunteerId: this.userMess.id }).then(res => {
        // this.$api.messageListNew({ volunteerId: '94fce6035a984d0ebc84604b0cd56dc5' }).then(res => {
        // console.log(res)
        this.newsUnread = res.data
      })

    },
    //退出登录
    quit() {
      this.$api.logout().then(res => { })
      // this.$store.commit('logout')

      window.location.href = gl.rzUrl;
    },
    checkLogin(callback) {
      // let userObj = JSON.parse(localStorage.getItem("userObj"))
      this.$api.getUserByID({ volunteerId: this.$cookies.get('sso_userId') }).then(res => {
        // console.log(res)
        // localStorage.setItem('hasLogin', true)
        // localStorage.setItem('userId', userObj.id)
        let resp = { status: "", params: {} }
        if (res.data.volunteerInfo == null) {
          resp.status = null
        } else {
          let status = res.data.volunteerInfo.status
          let applyNumber = res.data.volunteerInfo.applyNumber
          let refuseType = res.data.volunteerInfo.refuseType
          let currentDate = res.data.currentDate
          let integralResult = res.data.integralResult
          let keepCount = res.data.keepCount
          let exitType = res.data.volunteerInfo.exitType
          let refuseReason = res.data.volunteerInfo.refuseReason

          localStorage.setItem('userObj', JSON.stringify(res.data.volunteerInfo))
          this.$store.commit("setData", {
            key: "user",
            val: JSON.stringify(res.data.volunteerInfo)
          });
          if (status == 0) {
            resp.status = 0   //您的资料已提交到后台正在审核中！
          } else if (status == 1) {
            if (applyNumber == 3) {
              resp.status = 1   //您的申请志愿者资格机会已用光
            } else {
              if (refuseType == 1) {
                resp.status = 2  //驳回原因：您的资料填写错误，请重新填写提交！
                resp.params.refuseReason = refuseReason
                /********************************************************** */
                resp.params.surplus = 3 - parseInt(applyNumber)  //	您还有2/0次资料提交机会！
              } else {
                resp.status = 3  //驳回原因：试用期不合格
                /********************************************************** */
                resp.params.surplus = 3 - parseInt(applyNumber)  //	您还有2/0次资料提交机会！
              }
            }
          } else if (status == 2) {
            resp.status = 4  //首页
          } else if (status == 3) {
            let date = new Date(currentDate)
            let year = date.getFullYear();
            let start = Date.parse(year + '-01-' + '01' + ' ' + '02:00:00')
            let end = Date.parse(year + '-03-' + '31' + ' ' + '23:59:00')
            let end2 = Date.parse(year + '-01-' + '15' + ' ' + '23:59:00')
            // console.log(currentDate > start, currentDate < end)
            // if (currentDate > start && currentDate < end) {
            if (currentDate > start && currentDate < end) {
              if (integralResult == null || integralResult.integralResult == 1 || integralResult.integralResult == 2) {
                resp.status = 4  //首页
              } else {
                if (integralResult.keepQualification == 1) {
                  if (integralResult.status == 2) {

                    resp.status = 4  //首页
                  } else if (integralResult.status == 0) {
                    resp.status = 5  //保留资格正在审核中 ,您的申请保留资格审批中，请耐心等待！
                  }
                } else {
                  if (keepCount == 1) {
                    resp.status = 7 // 您本年度积分不合格，暂无保留资格申请？
                  } else {
                    if (currentDate < end2) {
                      resp.status = 8 // 您本年度积分不合格，是否申请保留资格？
                      this.$api.getAuditScore().then(res => {
                        let auditScore = res.data;
                        if (integralResult.totalIntegral < auditScore) {
                          resp.params.reason = "由于本年度积分低于" + auditScore + "，需向志愿者负责人递交本年度服务说明，等待审核通过"
                        } else { resp.params.reason = "上年所欠时长需要在今年补齐" }
                      });
                    } else {
                      resp.status = 7 // 您本年度积分不合格，暂无保留资格申请
                    }
                  }
                }
              }
            } else {
              resp.status = 4  //首页
            }
          } else if (status == 4) {
            // resp.status = 10 // 您已退出志愿者系统！
            if (exitType == 1 || exitType == 2 || exitType == 3) {
              resp.status = 10 // 您已退出志愿者系统！

            } else {
              resp.status = 6  //保您的申请保留资格被驳回，您已退出志愿者系统！ 驳回原因：不想给你通过
              resp.params.reason = integralResult.refuseReason //表示驳回原因
            }
          }

        }
        callback(resp)
      })
    },
    goReturn() {
      // console.log(this.lastRoute)
      // let parent = this.$route.meta.menuActive
      // this.$router.push({ name: parent })
      // let last = this.lastRoute.name
      // let params = this.lastRoute.params
      // this.$router.push({ name: last, params: params })
      this.$router.go(-1)
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // this.loading = this.$loading({
    //   lock: true,
    //   text: 'Loading',
    //   spinner: 'el-icon-loading',
    //   background: 'rgba(255 , 255, 255, 0.9)'
    // });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // console.log(this.$cookies.get('sso_userId'))
    this.navHide = this.$route.meta.navHide ? true : false
    this.returnBut = this.$route.meta.returnBut ? true : false

    this.init()
    // this.$store.commit('setData', { key: 'lastRoute', val: "'qq' " })


    // let age
    let _this = this
    this.checkLogin((res) => {

      // console.log(res.status)

      // this.fullscreenLoading = false;
      setTimeout(() => {
        _this.$store.commit('setLoading', false);
        if (res.status == null) _this.$router.replace({ name: "register", params: { type: 'set' } });
        else if (res.status == 0) _this.$router.replace({ name: "tipWarning", params: { status: res.status } });
        else if (res.status == 1) _this.$router.replace({ name: "tipWarning", params: { status: res.status, obj: res } });
        else if (res.status == 2) _this.$router.replace({ name: "tipWarning", params: { status: res.status, obj: res.params.surplus,refuseReason: res.params.refuseReason } });
        else if (res.status == 3) _this.$router.replace({ name: "tipWarning", params: { status: res.status, obj: res.params.surplus } });
        else if (res.status == 5) _this.$router.replace({ name: "tipWarning", params: { status: res.status, obj: res } });
        else if (res.status == 6) _this.$router.replace({ name: "tipWarning", params: { status: res.status, obj: res.params.reason } });
        else if (res.status == 7) _this.$router.replace({ name: "tipWarning", params: { status: res.status, obj: res } });
        else if (res.status == 8) _this.$router.replace({ name: "tipWarning", params: { status: res.status, obj: res.params.reason } });
        else if (res.status == 9) _this.$router.replace({ name: "tipWarning", params: { status: res.status, obj: res } });
        else if (res.status == 10) _this.$router.replace({ name: "tipWarning", params: { status: res.status, obj: res } });
      }, 1000);




      // 
      // this.fullscreenLoading = true;
    })

  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
@import "./Main.less";
.unread {
  position: absolute;
  top: calc(50% - 4px);
  right: 20px;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background-color: chocolate;
  display: inline-block;
}
</style>
